export default function FooterSection() {
  return (
    <footer className=" bg-background-100 border-t border-foreground-100/10">
      <div className=" max-w-7xl mx-auto px-4 md:px-6 pt-16 md:pt-20 pb-8">
        <div className=" grid grid-cols-1 sm:grid-cols-2 gap-10 md:gap-12 mb-16">
          <div>
            <h4 className="text-foreground-500 text-xs tracking-[0.2em] uppercase font-semibold mb-5">Information</h4>
            <div className="space-y-3">
              <a href="#about" className="block text-foreground-400 text-sm hover:text-foreground-950 transition-colors whitespace-nowrap">About</a>
              <a href="#menu" className="block text-foreground-400 text-sm hover:text-foreground-950 transition-colors whitespace-nowrap">Menu</a>
              <a href="#info" className="block text-foreground-400 text-sm hover:text-foreground-950 transition-colors whitespace-nowrap">営業案内</a>
              <a href="#access" className="block text-foreground-400 text-sm hover:text-foreground-950 transition-colors whitespace-nowrap">アクセス</a>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-500 text-xs tracking-[0.2em] uppercase font-semibold mb-5">Social</h4>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 rounded-full bg-foreground-100/10 flex items-center justify-center hover:bg-primary-500/20 transition-colors"
              >
                <i className="ri-instagram-line text-foreground-400 hover:text-primary-400 text-lg transition-colors"></i>
              </a>
              <a
                href="https://line.me/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 rounded-full bg-foreground-100/10 flex items-center justify-center hover:bg-accent-500/20 transition-colors"
              >
                <i className="ri-line-line text-foreground-400 hover:text-accent-400 text-lg transition-colors"></i>
              </a>
              <a
                href="https://x.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 rounded-full bg-foreground-100/10 flex items-center justify-center hover:bg-foreground-200/20 transition-colors"
              >
                <i className="ri-twitter-x-line text-foreground-400 hover:text-foreground-500 text-lg transition-colors"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-100/10 pt-10 pb-4">
          <h2 className="font-heading text-6xl md:text-8xl lg:text-9xl font-bold text-foreground-100/60 text-center tracking-tighter leading-none select-none">
            TRATTORIA
          </h2>
        </div>

        <div className="border-t border-foreground-100/10 pt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <p className="text-foreground-100 text-xs " >
            &copy; {new Date().getFullYear()} Trattoria Sole. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}